import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import './i18n';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DestinationsSection } from './components/DestinationsSection';
import { ExperiencesSection } from './components/ExperiencesSection';
import { HotelsSection } from './components/HotelsSection';
import { YachtsSection } from './components/YachtsSection';
import { TailorMadeSection } from './components/TailorMadeSection';
import { AboutSection } from './components/AboutSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { DestinationPage } from './components/DestinationPage';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const sectionRefs = {
    home: useRef(null),
    destinations: useRef(null),
    experiences: useRef(null),
    hotels: useRef(null),
    yachts: useRef(null),
    tailorMade: useRef(null),
    about: useRef(null),
    testimonials: useRef(null),
    contact: useRef(null),
  };

  const handleNavigate = (section) => {
    // Handle destination detail pages
    if (section.startsWith('destination-')) {
      setCurrentPage(section);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    // If we're on a destination page, go back to home first
    if (currentPage.startsWith('destination-') && section !== 'home') {
      setCurrentPage('home');
      setTimeout(() => {
        const ref = sectionRefs[section];
        if (ref?.current) {
          ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
      return;
    }

    if (section === 'home') {
      setCurrentPage('home');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const ref = sectionRefs[section];
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Check if viewing a destination page
  const isDestinationPage = currentPage.startsWith('destination-');
  const destinationId = isDestinationPage ? currentPage.replace('destination-', '') : null;

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Header onNavigate={handleNavigate} />
      
      {isDestinationPage ? (
        <DestinationPage 
          destinationId={destinationId} 
          onNavigate={handleNavigate}
        />
      ) : (
        <>
          <div ref={sectionRefs.home}>
            <HeroSection onNavigate={handleNavigate} />
          </div>
          <div ref={sectionRefs.destinations}>
            <DestinationsSection onNavigate={handleNavigate} />
          </div>
          <div ref={sectionRefs.experiences}>
            <ExperiencesSection onNavigate={handleNavigate} />
          </div>
          <div ref={sectionRefs.hotels}>
            <HotelsSection onNavigate={handleNavigate} />
          </div>
          <div ref={sectionRefs.yachts}>
            <YachtsSection onNavigate={handleNavigate} />
          </div>
          <div ref={sectionRefs.tailorMade}>
            <TailorMadeSection onNavigate={handleNavigate} />
          </div>
          <div ref={sectionRefs.about}>
            <AboutSection />
          </div>
          <div ref={sectionRefs.testimonials}>
            <TestimonialsSection />
          </div>
          <div ref={sectionRefs.contact}>
            <ContactSection />
          </div>
          <CTASection onNavigate={handleNavigate} />
        </>
      )}
      
      <Footer onNavigate={handleNavigate} />
    </div>
  );
}

export default App;
